
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "D:\\My Websites\\Snap Cash\\code\\frontend\\v2\\resources\\app\\js\\main\\pages\\login.js";
              export default OriginalModule.default;
              export * from "D:\\My Websites\\Snap Cash\\code\\frontend\\v2\\resources\\app\\js\\main\\pages\\login.js";